import React, { useContext } from "react"
import styled, { css } from "styled-components"
import { rem } from "polished"
import { Row, Col } from "react-flexbox-grid"
import { motion } from "framer-motion"

import { LoadedContext } from "../loaded-context"
import { UserContext } from "../global-context"

import Container from "../container"

import { BerlinTime, LaTime } from "../time-zones/times"

const StyledCol = styled(Col)`
  white-space: nowrap;
`

const NavInfo = styled.div`
  display: block;
  padding-top: ${rem(15)};
  line-height: 1.2;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  color: currentColor;

  ${props =>
    props.textColor &&
    css`
      color: ${props => props.textColor};
    `}

  .timezone-container {
    padding-top: 7.5%;
    margin-top: ${rem(15)};

    @media ${props => props.theme.mobileDown} {
      font-size: ${rem(14)};
    }
  }
`

const TimeZoneTextWrapper = styled.div`
  overflow: hidden;
`

const StaticInfo = () => {
  const loadedContext = useContext(LoadedContext)
  const globalContext = useContext(UserContext)

  // console.log("global context: ", globalContext)

  return (
    <NavInfo textColor={globalContext.value}>
      <Container>
        <div className="timezone-container">
          <Row>
            <StyledCol lg={2} xs={4} lgOffset={5}>
              <TimeZoneTextWrapper>
                <motion.div
                  initial={{ opacity: 0, y: "100%" }}
                  animate={loadedContext.loaded && { opacity: 1, y: 0 }}
                  transition={{ duration: 0.75, delay: 0 }}
                >
                  BERLIN:
                </motion.div>
              </TimeZoneTextWrapper>

              <TimeZoneTextWrapper>
                <motion.div
                  initial={{ opacity: 0, y: "100%" }}
                  animate={loadedContext.loaded && { opacity: 1, y: 0 }}
                  transition={{ duration: 0.75, delay: 0.1 }}
                >
                  <BerlinTime />
                </motion.div>
              </TimeZoneTextWrapper>
            </StyledCol>

            <StyledCol lg={2} xs={4}>
              <TimeZoneTextWrapper>
                <motion.div
                  initial={{ opacity: 0, y: "100%" }}
                  animate={loadedContext.loaded && { opacity: 1, y: 0 }}
                  transition={{ duration: 0.75, delay: 0.2 }}
                >
                  LOS ANGELES:
                </motion.div>
              </TimeZoneTextWrapper>

              <TimeZoneTextWrapper>
                <motion.div
                  initial={{ opacity: 0, y: "100%" }}
                  animate={loadedContext.loaded && { opacity: 1, y: 0 }}
                  transition={{ duration: 0.75, delay: 0.3 }}
                >
                  <LaTime />
                </motion.div>
              </TimeZoneTextWrapper>
            </StyledCol>
          </Row>
        </div>
      </Container>
    </NavInfo>
  )
}

export default StaticInfo
